import { FormInstance } from "antd/es/form";
import { Guid } from "guid-typescript";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISTDCustomer_View_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISTDCustomer_View_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  GetUserWithGroupDetails: any[];
  GetUserWithGroupDetails_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  SelectSTDCustomer: any[];
  SelectSTDCustomer_dummy: any[];
  GetCustomerProducts: any[];
  GetCustomerProducts_dummy: any[];
  GetCustomerProductFile: any[];
  GetCustomerProductFile_dummy: any[];
  GetCustomerStationWithCustId: any[];
  GetCustomerStationWithCustId_dummy: any[];
  DownloadFile: any;
  DownloadFile_dummy: any;
  UploadFile: any[];
  UploadFile_dummy: any[];
  UpdateCustomerLogo: number;
  UpdateCustomerLogo_dummy: number;
  Base64PrefixRemove2: string;
  Base64PrefixRemove2_dummy: string;
  ValidateStationsInExcel4: string;
  ValidateStationsInExcel4_dummy: string;
  SaveCustomerProductsFromExcel: string;
  SaveCustomerProductsFromExcel_dummy: string;
  SaveComplexDataExcel4: string;
  SaveComplexDataExcel4_dummy: string;
  STDCustomerProductFileSave: number;
  STDCustomerProductFileSave_dummy: number;
  Notify: boolean;
  Notify_dummy: boolean;
  isComp89335Visible: "visible" | "hidden";
  isComp877155Visible: "visible" | "hidden";
  isComp786246Visible: "visible" | "hidden";
  isComp257523Visible: "visible" | "hidden";
  isComp366305Visible: "visible" | "hidden";
}

export class STDCustomer_View_ScreenBase extends React.PureComponent<
  ISTDCustomer_View_ScreenProps,
  any
> {
  stdcustomer_view_8334515_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "9be9a2ff-05ee-4ab3-83dd-fd7be1def69c",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 796540, PropertyName: "value", Value: "Müşteri Detay" },
        { Id: 7526160, PropertyName: "value", Value: "Firma Adı" },
        { Id: 3239153, PropertyName: "value", Value: "Firma Kodu" },
        { Id: 5039300, PropertyName: "value", Value: "OLuşturulma Tarihi" },
        { Id: 233257, PropertyName: "value", Value: "Firma Logo" },
        { Id: 757693, PropertyName: "value", Value: "Müşteri Ürün Dosyası" },
        { Id: 694440, PropertyName: "label", Value: "Yükle" },
        {
          Id: 8334515,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 15895, PropertyName: "value", Value: "[datafield:numvalue]" },
        { Id: 3095041, PropertyName: "title", Value: "İstasyon Adı" },
        { Id: 864987, PropertyName: "value", Value: "[datafield:stationname]" },
        {
          Id: 259355,
          PropertyName: "title",
          Value: "İstasyon Teslimat Adresi",
        },
        {
          Id: 997597,
          PropertyName: "value",
          Value: "[datafield:stationlocationno]",
        },
        { Id: 521943, PropertyName: "title", Value: "İstasyon ID" },
        {
          Id: 954391,
          PropertyName: "value",
          Value: "[datafield:stationidentifier]",
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.stdcustomer_view_8334515_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      GetUserWithGroupDetails: [],
      IfThenElse: false,
      SelectSTDCustomer: [],
      GetCustomerProducts: [],
      GetCustomerProductFile: [],
      GetCustomerStationWithCustId: [],
      DownloadFile: "",
      UploadFile: [],
      UpdateCustomerLogo: 0,
      Base64PrefixRemove2: "",
      NAVIGATE: "",
      isComp89335Visible: "hidden",
      isComp877155Visible: "hidden",
      isComp786246Visible: "hidden",
      isComp257523Visible: "hidden",
      isComp366305Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("stdcustomer_view", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.STDCustomer_ViewPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("stdcustomer_view", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("stdcustomer_view", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.STDCustomer_ViewPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      stdcustomer_view_413762_value:
        this.state.SelectSTDCustomer?.at?.(0)?.customerLogo ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  STDCustomer_ViewPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDCustomer_View/STDCustomer_ViewPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserWithGroupDetails = result?.data.getUserWithGroupDetails;
    stateVars.isComp877155Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].customerView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].customerView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp257523Visible =
      (ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCustomerProductFile !== undefined
            ? stateVars.GetCustomerProductFile?.length > 0
              ? stateVars.GetCustomerProductFile[0].fileData
              : null
            : this.state.GetCustomerProductFile?.length > 0
            ? this.state.GetCustomerProductFile[0].fileData
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) &&
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.GetUserWithGroupDetails !== undefined
              ? stateVars.GetUserWithGroupDetails?.length > 0
                ? stateVars.GetUserWithGroupDetails[0].stationsCreate
                : null
              : this.state.GetUserWithGroupDetails?.length > 0
              ? this.state.GetUserWithGroupDetails[0].stationsCreate
              : null
          ),
          true
        )) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDCustomer_ViewPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDCustomer_ViewPageInit_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "STDCustomer_View",
      "NavigateScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDCustomer_ViewPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].customerView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].customerView
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.STDCustomer_ViewPageInit_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDCustomer_ViewPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDCustomer_ViewPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      CustomerId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      CustomerId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      CustomerId_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDCustomer_View/STDCustomer_ViewPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectSTDCustomer = result?.data.selectSTDCustomer;
    formVars.stdcustomer_view_1957933_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].name
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].name
        : null
    );
    formVars.stdcustomer_view_1982842_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].customerCode
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].customerCode
        : null
    );
    formVars.stdcustomer_view_3092934_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].createdDate
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].createdDate
        : null
    );
    formVars.stdcustomer_view_413762_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].customerLogo
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].customerLogo
        : null
    );
    stateVars.isComp89335Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDCustomer !== undefined
            ? stateVars.SelectSTDCustomer?.length > 0
              ? stateVars.SelectSTDCustomer[0].customerLogo
              : null
            : this.state.SelectSTDCustomer?.length > 0
            ? this.state.SelectSTDCustomer[0].customerLogo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetCustomerProducts = result?.data.getCustomerProducts;
    stateVars.GetCustomerProductFile = result?.data.getCustomerProductFile;
    formVars.stdcustomer_view_54896_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCustomerProductFile !== undefined
        ? stateVars.GetCustomerProductFile?.length > 0
          ? stateVars.GetCustomerProductFile[0].fileName
          : null
        : this.state.GetCustomerProductFile?.length > 0
        ? this.state.GetCustomerProductFile[0].fileName
        : null
    );
    stateVars.isComp786246Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCustomerProductFile !== undefined
            ? stateVars.GetCustomerProductFile?.length > 0
              ? stateVars.GetCustomerProductFile[0].fileData
              : null
            : this.state.GetCustomerProductFile?.length > 0
            ? this.state.GetCustomerProductFile[0].fileData
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp257523Visible =
      (ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCustomerProductFile !== undefined
            ? stateVars.GetCustomerProductFile?.length > 0
              ? stateVars.GetCustomerProductFile[0].fileData
              : null
            : this.state.GetCustomerProductFile?.length > 0
            ? this.state.GetCustomerProductFile[0].fileData
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) &&
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.GetUserWithGroupDetails !== undefined
              ? stateVars.GetUserWithGroupDetails?.length > 0
                ? stateVars.GetUserWithGroupDetails[0].stationsCreate
                : null
              : this.state.GetUserWithGroupDetails?.length > 0
              ? this.state.GetUserWithGroupDetails[0].stationsCreate
              : null
          ),
          true
        )) === true
        ? "visible"
        : "hidden";
    stateVars.GetCustomerStationWithCustId =
      result?.data.getCustomerStationWithCustId;

    stateVars.isComp366305Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCustomerStationWithCustId !== undefined
            ? stateVars.GetCustomerStationWithCustId?.length > 0
              ? stateVars.GetCustomerStationWithCustId[0].stationName
              : null
            : this.state.GetCustomerStationWithCustId?.length > 0
            ? this.state.GetCustomerStationWithCustId[0].stationName
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDCustomer_ViewPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDCustomer_ViewPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.stdcustomer_view_1957933_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].name
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].name
        : null
    );

    formVars.stdcustomer_view_1982842_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].customerCode
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].customerCode
        : null
    );

    formVars.stdcustomer_view_3092934_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].createdDate
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].createdDate
        : null
    );

    stateVars.isComp89335Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDCustomer !== undefined
            ? stateVars.SelectSTDCustomer?.length > 0
              ? stateVars.SelectSTDCustomer[0].customerLogo
              : null
            : this.state.SelectSTDCustomer?.length > 0
            ? this.state.SelectSTDCustomer[0].customerLogo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.stdcustomer_view_413762_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].customerLogo
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].customerLogo
        : null
    );

    stateVars.isComp877155Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].customerView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].customerView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp786246Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCustomerProductFile !== undefined
            ? stateVars.GetCustomerProductFile?.length > 0
              ? stateVars.GetCustomerProductFile[0].fileData
              : null
            : this.state.GetCustomerProductFile?.length > 0
            ? this.state.GetCustomerProductFile[0].fileData
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.stdcustomer_view_54896_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCustomerProductFile !== undefined
        ? stateVars.GetCustomerProductFile?.length > 0
          ? stateVars.GetCustomerProductFile[0].fileName
          : null
        : this.state.GetCustomerProductFile?.length > 0
        ? this.state.GetCustomerProductFile[0].fileName
        : null
    );

    stateVars.isComp257523Visible =
      (ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCustomerProductFile !== undefined
            ? stateVars.GetCustomerProductFile?.length > 0
              ? stateVars.GetCustomerProductFile[0].fileData
              : null
            : this.state.GetCustomerProductFile?.length > 0
            ? this.state.GetCustomerProductFile[0].fileData
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) &&
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.GetUserWithGroupDetails !== undefined
              ? stateVars.GetUserWithGroupDetails?.length > 0
                ? stateVars.GetUserWithGroupDetails[0].stationsCreate
                : null
              : this.state.GetUserWithGroupDetails?.length > 0
              ? this.state.GetUserWithGroupDetails[0].stationsCreate
              : null
          ),
          true
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp366305Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCustomerStationWithCustId !== undefined
            ? stateVars.GetCustomerStationWithCustId?.length > 0
              ? stateVars.GetCustomerStationWithCustId[0].stationName
              : null
            : this.state.GetCustomerStationWithCustId?.length > 0
            ? this.state.GetCustomerStationWithCustId[0].stationName
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_8334515 =
      stateVars.GetCustomerStationWithCustId ??
      this.state.GetCustomerStationWithCustId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDCustomer_ViewComponent_968274_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDCustomer_ViewComponent_276142_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DownloadFile = await ReactSystemFunctions.downloadFile(
      ReactSystemFunctions.toString(
        this,
        stateVars.SelectSTDCustomer !== undefined
          ? stateVars.SelectSTDCustomer?.length > 0
            ? stateVars.SelectSTDCustomer[0].customerLogo
            : null
          : this.state.SelectSTDCustomer?.length > 0
          ? this.state.SelectSTDCustomer[0].customerLogo
          : null
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.SelectSTDCustomer !== undefined
          ? stateVars.SelectSTDCustomer?.length > 0
            ? stateVars.SelectSTDCustomer[0].name
            : null
          : this.state.SelectSTDCustomer?.length > 0
          ? this.state.SelectSTDCustomer[0].name
          : null
      )
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDCustomer_ViewComponent_877155_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.UploadFile = (
      (await ReactSystemFunctions.uploadFilesWithInfo(
        ReactSystemFunctions.convertToTypeByName("", "string")
      )) as any
    ).data;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDCustomer_ViewComponent_877155_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDCustomer_ViewComponent_877155_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerLogo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.UploadFile !== undefined
            ? stateVars.UploadFile?.length > 0
              ? stateVars.UploadFile[0].data
              : null
            : this.state.UploadFile?.length > 0
            ? this.state.UploadFile[0].data
            : null
        ),
        "string"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Id_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDCustomer_View/STDCustomer_ViewComponent_877155_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UpdateCustomerLogo = result?.data.updateCustomerLogo;
    stateVars.SelectSTDCustomer = result?.data.selectSTDCustomer;
    formVars.stdcustomer_view_1957933_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].name
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].name
        : null
    );
    formVars.stdcustomer_view_1982842_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].customerCode
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].customerCode
        : null
    );
    formVars.stdcustomer_view_3092934_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].createdDate
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].createdDate
        : null
    );
    formVars.stdcustomer_view_413762_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].customerLogo
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].customerLogo
        : null
    );
    stateVars.isComp89335Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDCustomer !== undefined
            ? stateVars.SelectSTDCustomer?.length > 0
              ? stateVars.SelectSTDCustomer[0].customerLogo
              : null
            : this.state.SelectSTDCustomer?.length > 0
            ? this.state.SelectSTDCustomer[0].customerLogo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDCustomer_ViewComponent_877155_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDCustomer_ViewComponent_877155_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.stdcustomer_view_1957933_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].name
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].name
        : null
    );

    formVars.stdcustomer_view_1982842_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].customerCode
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].customerCode
        : null
    );

    formVars.stdcustomer_view_3092934_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].createdDate
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].createdDate
        : null
    );

    formVars.stdcustomer_view_413762_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].customerLogo
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].customerLogo
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDCustomer_ViewComponent_154066_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DownloadFile = await ReactSystemFunctions.downloadFile(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetCustomerProductFile !== undefined
          ? stateVars.GetCustomerProductFile?.length > 0
            ? stateVars.GetCustomerProductFile[0].fileData
            : null
          : this.state.GetCustomerProductFile?.length > 0
          ? this.state.GetCustomerProductFile[0].fileData
          : null
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.GetCustomerProductFile !== undefined
          ? stateVars.GetCustomerProductFile?.length > 0
            ? stateVars.GetCustomerProductFile[0].fileName
            : null
          : this.state.GetCustomerProductFile?.length > 0
          ? this.state.GetCustomerProductFile[0].fileName
          : null
      )
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDCustomer_ViewComponent_694440_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.UploadFile = (
      (await ReactSystemFunctions.uploadFilesWithInfo(
        ReactSystemFunctions.convertToTypeByName("", "string")
      )) as any
    ).data;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDCustomer_ViewComponent_694440_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDCustomer_ViewComponent_694440_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      base64_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.UploadFile !== undefined
            ? stateVars.UploadFile?.length > 0
              ? stateVars.UploadFile[0].data
              : null
            : this.state.UploadFile?.length > 0
            ? this.state.UploadFile[0].data
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDCustomer_View/STDCustomer_ViewComponent_694440_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Base64PrefixRemove2 = result?.data.base64PrefixRemove2;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDCustomer_ViewComponent_694440_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDCustomer_ViewComponent_694440_onClick_if2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDCustomer_ViewComponent_694440_onClick_if21_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDCustomer_ViewComponent_694440_onClick_if2f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      base64Data_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.Base64PrefixRemove2),
        "string"
      ),
      customerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDCustomer !== undefined
            ? stateVars.SelectSTDCustomer?.length > 0
              ? stateVars.SelectSTDCustomer[0].id
              : null
            : this.state.SelectSTDCustomer?.length > 0
            ? this.state.SelectSTDCustomer[0].id
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDCustomer_View/STDCustomer_ViewComponent_694440_onClick_if2f1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ValidateStationsInExcel4 = result?.data.validateStationsInExcel4;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDCustomer_ViewComponent_694440_onClick_if2f11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDCustomer_ViewComponent_694440_onClick_if2f1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      base64Data_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.Base64PrefixRemove2),
        "string"
      ),
      customerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDCustomer !== undefined
            ? stateVars.SelectSTDCustomer?.length > 0
              ? stateVars.SelectSTDCustomer[0].id
              : null
            : this.state.SelectSTDCustomer?.length > 0
            ? this.state.SelectSTDCustomer[0].id
            : null
        ),
        "Guid"
      ),
      base64Data_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.Base64PrefixRemove2),
        "string"
      ),
      customerId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDCustomer !== undefined
            ? stateVars.SelectSTDCustomer?.length > 0
              ? stateVars.SelectSTDCustomer[0].id
              : null
            : this.state.SelectSTDCustomer?.length > 0
            ? this.state.SelectSTDCustomer[0].id
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDCustomer_View/STDCustomer_ViewComponent_694440_onClick_if2f1f1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SaveCustomerProductsFromExcel =
      result?.data.saveCustomerProductsFromExcel;
    stateVars.SaveComplexDataExcel4 = result?.data.saveComplexDataExcel4;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDCustomer_ViewComponent_694440_onClick_if2f1f11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDCustomer_ViewComponent_694440_onClick_if2f1f1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDCustomer !== undefined
            ? stateVars.SelectSTDCustomer?.length > 0
              ? stateVars.SelectSTDCustomer[0].id
              : null
            : this.state.SelectSTDCustomer?.length > 0
            ? this.state.SelectSTDCustomer[0].id
            : null
        ),
        "Guid"
      ),
      FileData_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.UploadFile !== undefined
            ? stateVars.UploadFile?.length > 0
              ? stateVars.UploadFile[0].data
              : null
            : this.state.UploadFile?.length > 0
            ? this.state.UploadFile[0].data
            : null
        ),
        "string"
      ),
      FileName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.UploadFile !== undefined
            ? stateVars.UploadFile?.length > 0
              ? stateVars.UploadFile[0].name
              : null
            : this.state.UploadFile?.length > 0
            ? this.state.UploadFile[0].name
            : null
        ),
        "string"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDCustomer_View/STDCustomer_ViewComponent_694440_onClick_if2f1f1f1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDCustomerProductFileSave =
      result?.data.stdCustomerProductFileSave;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  STDCustomer_ViewComponent_694440_onClick_if2f1f1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDCustomer !== undefined
            ? stateVars.SelectSTDCustomer?.length > 0
              ? stateVars.SelectSTDCustomer[0].id
              : null
            : this.state.SelectSTDCustomer?.length > 0
            ? this.state.SelectSTDCustomer[0].id
            : null
        ),
        "Guid"
      ),
      FileData_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.UploadFile !== undefined
            ? stateVars.UploadFile?.length > 0
              ? stateVars.UploadFile[0].data
              : null
            : this.state.UploadFile?.length > 0
            ? this.state.UploadFile[0].data
            : null
        ),
        "string"
      ),
      FileName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.UploadFile !== undefined
            ? stateVars.UploadFile?.length > 0
              ? stateVars.UploadFile[0].name
              : null
            : this.state.UploadFile?.length > 0
            ? this.state.UploadFile[0].name
            : null
        ),
        "string"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCustomerProductFile !== undefined
            ? stateVars.GetCustomerProductFile?.length > 0
              ? stateVars.GetCustomerProductFile[0].id
              : null
            : this.state.GetCustomerProductFile?.length > 0
            ? this.state.GetCustomerProductFile[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDCustomer_View/STDCustomer_ViewComponent_694440_onClick_if2f1f1e1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDCustomerProductFileSave =
      result?.data.stdCustomerProductFileSave;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  STDCustomer_ViewComponent_694440_onClick_if2f1f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCustomerProductFile !== undefined
            ? stateVars.GetCustomerProductFile?.length > 0
              ? stateVars.GetCustomerProductFile[0].id
              : null
            : this.state.GetCustomerProductFile?.length > 0
            ? this.state.GetCustomerProductFile[0].id
            : null
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.STDCustomer_ViewComponent_694440_onClick_if2f1f1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDCustomer_ViewComponent_694440_onClick_if2f1f1e1();
      if (isErrorOccurred) return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "e9911568_feb6_0b2b_c605_023986c0ec78_notify",
        this.defaultML,
        "Kurulum dosyası başarıyla işlendi."
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDCustomer_ViewComponent_694440_onClick_if2f1f12_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDCustomer_ViewComponent_694440_onClick_if2f1f12_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDCustomer !== undefined
            ? stateVars.SelectSTDCustomer?.length > 0
              ? stateVars.SelectSTDCustomer[0].id
              : null
            : this.state.SelectSTDCustomer?.length > 0
            ? this.state.SelectSTDCustomer[0].id
            : null
        ),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDCustomer_View/STDCustomer_ViewComponent_694440_onClick_if2f1f12_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCustomerProductFile = result?.data.getCustomerProductFile;
    formVars.stdcustomer_view_54896_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCustomerProductFile !== undefined
        ? stateVars.GetCustomerProductFile?.length > 0
          ? stateVars.GetCustomerProductFile[0].fileName
          : null
        : this.state.GetCustomerProductFile?.length > 0
        ? this.state.GetCustomerProductFile[0].fileName
        : null
    );
    stateVars.isComp786246Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCustomerProductFile !== undefined
            ? stateVars.GetCustomerProductFile?.length > 0
              ? stateVars.GetCustomerProductFile[0].fileData
              : null
            : this.state.GetCustomerProductFile?.length > 0
            ? this.state.GetCustomerProductFile[0].fileData
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp257523Visible =
      (ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCustomerProductFile !== undefined
            ? stateVars.GetCustomerProductFile?.length > 0
              ? stateVars.GetCustomerProductFile[0].fileData
              : null
            : this.state.GetCustomerProductFile?.length > 0
            ? this.state.GetCustomerProductFile[0].fileData
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) &&
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.GetUserWithGroupDetails !== undefined
              ? stateVars.GetUserWithGroupDetails?.length > 0
                ? stateVars.GetUserWithGroupDetails[0].stationsCreate
                : null
              : this.state.GetUserWithGroupDetails?.length > 0
              ? this.state.GetUserWithGroupDetails[0].stationsCreate
              : null
          ),
          true
        )) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  STDCustomer_ViewComponent_694440_onClick_if2f1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(this, this.state.ValidateStationsInExcel4),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDCustomer_ViewComponent_694440_onClick_if2f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isShorterOrEqualLength(
        ReactSystemFunctions.toString(
          this,
          this.state.ValidateStationsInExcel4
        ),
        "4"
      )
    ) {
      isErrorOccurred =
        await this.STDCustomer_ViewComponent_694440_onClick_if2f1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDCustomer_ViewComponent_694440_onClick_if2f1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDCustomer_ViewComponent_694440_onClick_if2e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "64b8dd9b_39c9_e8a4_080e_c0d4f4b1e604_notify",
        this.defaultML,
        "Müşteriye ait tanımlı istasyon bulunamadı!"
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDCustomer_ViewComponent_694440_onClick_if21_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCustomerStationWithCustId !== undefined
            ? stateVars.GetCustomerStationWithCustId?.length > 0
              ? stateVars.GetCustomerStationWithCustId[0].id
              : null
            : this.state.GetCustomerStationWithCustId?.length > 0
            ? this.state.GetCustomerStationWithCustId[0].id
            : null
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.STDCustomer_ViewComponent_694440_onClick_if2f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDCustomer_ViewComponent_694440_onClick_if2e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDCustomer_ViewComponent_694440_onClick_else2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "bab0173f_a04b_3643_bff5_c0b919613add_notify",
        this.defaultML,
        "Dosya yüklenmedi!"
      ),
      ReactSystemFunctions.convertToTypeByName("info", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDCustomer_ViewComponent_694440_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.UploadFile !== undefined
            ? stateVars.UploadFile?.length > 0
              ? stateVars.UploadFile[0].data
              : null
            : this.state.UploadFile?.length > 0
            ? this.state.UploadFile[0].data
            : null
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.STDCustomer_ViewComponent_694440_onClick_if2();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDCustomer_ViewComponent_694440_onClick_else2();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDCustomer_ViewComponent_864987_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "Station_View",
      "Id",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "stdcustomer_view_8334515_value",
          "id"
        ),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "STDCustomer_View",
      "Station_View",
      "",
      "newTab",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (
      isFromMaster ||
      ((window.kuika?.disableSmartExecutePageInit?.["STDCustomer_View"] ??
        false) &&
        pageInitCallerNavDiIDs.indexOf(diId) > -1)
    ) {
      await this.STDCustomer_ViewPageInit();
    } else if (
      window.kuika?.serverRequestCount > 0 &&
      pageInitCallerNavDiIDs.indexOf(diId) > -1
    ) {
      await this.STDCustomer_ViewPageInit();
    }
  }
}
